export class WorkflowNotesResultDto {
    note: string;
    allowEdit: boolean; // Indicates if notes can be saved

    get displayPreviousNotes(): string {
        if (this.note) {
            return `${this.note.replace(/\r\n/g, '<br>')}`;
        } else {
            return null;
        }
    }
}
